import { MenuItemProcessingRule } from './interfaces';
import { availabilityOutsideCurrentScheduleRule } from '@core/domain/availability';
import { menuItemExistsRule } from './rules/menu-item-exists.rule';
import { menuItemServiceAvailabilityRule } from './rules/menu-item-service-availability.rule';
import { menuItemStockAvailabilityRule } from './rules/menu-item-stock-availability.rule';
import { menuItemPricesToBigIntRule } from './rules/menu-item-prices-to-bigint.rule';
import { menuItemRemoveInclusiveTaxesRule } from './rules/menu-item-remove-inclusive-taxes.rule';
import { menuItemSpecialPricesRule } from './rules/menu-item-special-prices.rule';

export class MenuItemFactory {
	createCatalogRules(): MenuItemProcessingRule[] {
		return [
			availabilityOutsideCurrentScheduleRule,
			menuItemServiceAvailabilityRule,
			menuItemStockAvailabilityRule,
			menuItemExistsRule,
			menuItemPricesToBigIntRule,
			menuItemRemoveInclusiveTaxesRule,
			menuItemSpecialPricesRule,
		];
	}
}
